module.exports = __webpack_public_path__ + "img/dreamnepal.8a69ea1e.png";